<template>
  <div
    class="gap-2 d-lg-flex d-none flex-column"
    style="min-width: 200px"
    v-if="store.activePage.name !== 'StampSetup'"
  >
    <template v-for="item in steps" :key="item.step">
      <FlexRow class="gap-2 align-items-center">
        <span
          class="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0 text-white fw-semibold"
          :class="item.active ? 'bg-primary' : 'bg-inactive'"
          style="width: 24px; height: 24px"
          >{{ item.step }}
        </span>
        <span
          class="fw-semibold fs-6"
          :class="item.active ? 'text-primary' : 'text-black'"
          >{{ item.name }}</span
        >
      </FlexRow>
      <template
        v-if="
          item.subItems &&
          (item.active || item.subItems.some((sub) => sub.active))
        "
      >
        <FlexCol class="gap-2">
          <FlexRow
            v-for="subItem in item.subItems"
            class="gap-2"
            :class="subItem.active ? 'text-primary' : 'text-black'"
            :key="subItem.step"
          >
            <span
              class="d-flex align-items-center justify-content-center flex-shrink-0"
              style="width: 24px; height: 24px; font-size: 12px"
            >
              &bull;
            </span>
            <span class="fs-6"> {{ subItem.name }} </span>
          </FlexRow>
        </FlexCol>
      </template>
    </template>
  </div>
  <div
    class="gap-1 d-lg-none d-flex"
    v-if="store.activePage.name !== 'StampSetup'"
  >
    <template v-for="item in stepsCombined" :key="item.step">
      <div
        class="flex-grow-1"
        :class="item.active ? 'bg-primary' : 'bg-dark-soft'"
        style="height: 10px"
      ></div>
    </template>
  </div>
</template>

<script setup>
import FlexCol from "@/components/layout/FlexCol.vue";
import FlexRow from "@/components/layout/FlexRow.vue";
import { useBrandSetupStore } from "@/stores/brand";
import { computed } from "vue";

const store = useBrandSetupStore();

const steps = computed(() => {
  return [
    {
      step: 1,
      name: "Brand Setup",
      active: store.activePage.name === "BrandSetup",
    },
    {
      step: 2,
      name: "Loyalty Brand Setup",
      active: store.activePage.name === "LoyaltySetup",
      subItems: [
        {
          step: 1,
          name: "Ways to earn points",
          active: store.activePage.name === "PointSetup",
        },
        {
          step: 2,
          name: "Ways to redeem points",
          active: store.activePage.name === "RewardSetup",
        },
      ],
    },
    {
      step: 3,
      name: "Get Your Credentials",
      active: store.activePage.name === "GetYourCredentials",
    },
  ];
});

const stepsCombined = computed(() => {
  let combined = [];
  steps.value.forEach((item) => {
    combined.push({
      step: item.step,
      name: item.name,
      active: item.active,
    });
    if (item.subItems) {
      item.subItems.forEach((sub) => {
        combined.push({
          step: `${item.step}.${sub.step}`,
          name: sub.name,
          active: sub.active,
        });
      });
    }
  });
  return combined;
});
</script>

<style scoped>
.bg-inactive {
  background-color: #7d7d7d;
}
</style>
